<template>
  <div class="content">
    <div class="content__title">
      <h1 class="title title--big title--theme">Мероприятия</h1>
    </div>
    <div v-if="$store.state.meProfile.user_permissions.can_edit_event" class="content__tabs">
      <div class="tabs-list">
        <ul class="tabs-list__body">
          <li class="tabs-list__item">
            <router-link
              :to="{ name: 'events-list' }"
              exact-active-class="tabs-list__link--active"
              class="tabs-list__link">Все мероприятия
            </router-link>
          </li>
          <li class="tabs-list__item">
            <router-link
              :to="{ name: 'events-manage' }"
              exact-active-class="tabs-list__link--active"
              class="tabs-list__link">Управление
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <router-view class="content__body"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'EventsLayout',
  mounted() {
    console.log(this.$store.state.meProfile)
  }
}
</script>
<style lang="sass">
.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
